import { render, staticRenderFns } from "./OrderCompleteBoleto.vue?vue&type=template&id=4b097140&scoped=true"
import script from "./OrderCompleteBoleto.vue?vue&type=script&lang=js"
export * from "./OrderCompleteBoleto.vue?vue&type=script&lang=js"
import style0 from "./OrderCompleteBoleto.vue?vue&type=style&index=0&id=4b097140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b097140",
  null
  
)

export default component.exports